export default {
  data() {
    return {
      throttleStartTime: Date.now()
    };
  },
  methods: {
    throttle(func, delay = 1000) {
      let now = Date.now();
      if (now - this.throttleStartTime >= delay) {
        func();
        this.throttleStartTime = Date.now();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/throttle.js